import $ from 'jquery';
import JsPath from './path';

require('../vendor/modernizr.touch.js');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

// Helper
import './helper';

import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';


(function ($) {
    /**
     * Ajax-Forms
     */
    $.fn.ajaxForm = function (conf) {
        const defaults = {};
        const config = $.extend(defaults, conf);
        $(this).find('form:first').submit(function () {

            const form = $(this);
            const ajaxform = $(form).find('input[name=ajaxform]').val();

            // Formular per Ajax senden?
            if (ajaxform > 0 && $(form).attr('enctype') != 'multipart/form-data') {
                $(form).find('input[name=ajaxform]').attr('name', 'ajax_form');
                const form_data = $(this).find('input:not([type=checkbox],[type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();
                console.log(form.attr('action'));
                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form_data,
                    success: function (html) {
                        const thisAjaxForm = $('#' + form.attr('id'));
                        thisAjaxForm.replaceWith(html);
                        thisAjaxForm.ajaxForm(conf);

                        var formtop = thisAjaxForm.offset().top;
                        if ($(window).scrollTop() > formtop) {
                            $('html,body').animate({ scrollTop: formtop }, 500);
                        }
                    }
                });
                return false;
            }
        });
    };

    /**
     * animateInputLabels
     */
    window.animateInputLabels = function () {
        // animate input labels (text input and select only)
        const formFieldsToAnimate = $('.form-field input[type="text"], .form-field input[type="email"], .form-field input[type="tel"], .form-field textarea, .form-field select');
        formFieldsToAnimate.focus(function () {
            $('label[for=\'' + $(this).attr('id') + '\']').addClass('active');
        });
        formFieldsToAnimate.blur(function () {
            if ($(this).val() == '') {
                $('label[for=\'' + $(this).attr('id') + '\']').removeClass('active');
            }
        });
    };

    /**
     * Doc Ready
     */
    $(document).ready(function () {
        // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
        $('html:first').removeClass('no-js').addClass('js');

        // bind ajax forms
        $('.ajaxform-wrap').ajaxForm();

        // toggle main menu
        const mainNavToggle = $('#menu-toggle');
        const mainNav = $('#main-nav');
        if (mainNavToggle.length > 0 && mainNav.length > 0) {
            [mainNavToggle, $('#fullpage-overlay')].forEach(function (trigger) {
                trigger.on('click', function () {
                    $('html').toggleClass('menu-open');
                });
            });
        }

        // submenu actions
        if (mainNav.length > 0) {
            // toggle submenu
            mainNav.find('li.dropdown').children('.toggle-dropdown').on('click', function () {
                $(this).toggleClass('active').next('ul').stop().slideToggle(150);
            });

            // automatically open submenu if a subpage is active
            mainNav.find('li.dropdown').find('li.active').closest('li.dropdown').children('ul').css('display', 'block').prev().addClass('active');
        }

        // text slideshow
        const textSlideshow = $('.text-slideshow');
        if (textSlideshow.length > 0) {
            textSlideshow.children('.text-slideshow-inner').slick({
                arrows: false,
                slidesToShow: 1,
                infinite: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 3,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            dots: true
                        }
                    }
                ]
            });
        }

        // accordion
        const accordionWrap = $('.accordion');
        if (accordionWrap.length > 0) {
            accordionWrap.find('.accordion-single').each(function () {
                $(this).children('.accordion-header').on('click', function () {
                    // toggle state
                    $(this).closest('.accordion-single').toggleClass('active');

                    // show up content
                    $(this).next('.accordion-content').stop().slideToggle(150);
                });
            });
        }

        // animate input labels
        animateInputLabels();
    });
})($);
